import { RUDDERSTACK_EVENTS } from "@/lib/rudderstack";
import { createTrackingConfig } from "../index";

export const ADMIN_USERS_TRACKING_EVENTS = {
  create: createTrackingConfig(RUDDERSTACK_EVENTS.ADMIN_USER_CREATE, (variables: any) => ({ ...variables })),
  update: createTrackingConfig(RUDDERSTACK_EVENTS.ADMIN_USER_EDIT, (variables: any) => ({ ...variables })),
  delete: createTrackingConfig(RUDDERSTACK_EVENTS.ADMIN_USER_DISABLE, (variables: any) => ({
    customer_user_id: variables?.user_id,
    email: variables?.email,
  })),
  activate: createTrackingConfig(RUDDERSTACK_EVENTS.ADMIN_USER_ACTIVATE, (variables: any) => ({
    customer_user_id: variables?.user_id,
    email: variables?.email,
    first_name: variables?.first_name,
    last_name: variables?.last_name,
  })),
  resetPassword: createTrackingConfig(RUDDERSTACK_EVENTS.ADMIN_USER_PASSWORD_RESET, (variables: any) => ({
    customer_user_id: variables?.user_id,
    email: variables?.email,
  })),
  addCustomer: createTrackingConfig(RUDDERSTACK_EVENTS.ADMIN_USER_CUSTOMER_ADD, (variables: any) => ({
    customer_user_id: variables?.user_id,
    email: variables?.email,
    role_id: variables?.role_id,
  })),
  removeCustomer: createTrackingConfig(RUDDERSTACK_EVENTS.ADMIN_USER_CUSTOMER_REMOVE, (variables: any) => ({
    customer_user_id: variables?.user_id,
    email: variables?.email,
  })),
} as const;
